import { render, staticRenderFns } from "./NouvelleOpportunite.vue?vue&type=template&id=c28082cc&scoped=true&"
import script from "./NouvelleOpportunite.vue?vue&type=script&lang=js&"
export * from "./NouvelleOpportunite.vue?vue&type=script&lang=js&"
import style0 from "./NouvelleOpportunite.vue?vue&type=style&index=0&id=c28082cc&prod&scoped=true&lang=css&"
import style1 from "./NouvelleOpportunite.vue?vue&type=style&index=1&id=c28082cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28082cc",
  null
  
)

export default component.exports